import React from 'react'
import PropTypes from 'prop-types'

const HideIcon = ({
  width = '20',
  height = '16',
  viewBox = '0 0 20 16',
  fill = 'none',
  ...props
}) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_479_415)">
        <path
          d="M9.89111 2.44629C10.036 2.44278 10.1803 2.45004 10.3237 2.46582C13.6659 2.7002 16.5627 5.01459 18.7974 7.77344C18.9208 7.93578 18.9193 8.19041 18.7974 8.35449C16.4427 11.2021 13.37 13.5439 9.89111 13.5518C9.6161 13.5649 9.34334 13.5438 9.07568 13.4912C6.63133 13.1735 4.42067 11.6596 2.59521 9.83496C2.08602 9.32056 1.5946 8.77405 1.14795 8.18066C1.09735 8.11571 1.10092 8.01567 1.14795 7.94727C1.57916 7.33543 2.0587 6.77141 2.55908 6.24121C4.43761 4.268 6.79851 2.6519 9.41943 2.46484C9.57538 2.44817 9.73297 2.44191 9.89111 2.44629ZM9.99951 4.66699C8.15875 4.66721 6.6665 6.16016 6.6665 8.00098C6.66665 9.84166 8.15884 11.3338 9.99951 11.334C11.8404 11.334 13.3333 9.8418 13.3335 8.00098C13.3335 6.16003 11.8405 4.66699 9.99951 4.66699Z"
          fill="currentColor"
        />
        <line
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="1.66667"
          x1="16.542"
          x2="3.57837"
          y1="1.50078"
          y2="14.4644"
        />
      </g>
      <defs>
        <clipPath id="clip0_479_415">
          <rect
            fill="white"
            height="15.5556"
            transform="translate(0 0.222656)"
            width="20"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

HideIcon.propTypes = {
  fill: PropTypes.string,
  height: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.string,
}

export default HideIcon
